<template>
    <div class="container">
        <div class="row dashboard">

            <div class="col-12">
                <h1 class="title">{{ $t('manage_profile') }}</h1>
                <h2 class="sub-title">{{ $t('manage_profile_subtitle') }}</h2>

                <div class="row">
                    <div class="col-md-3">
                        <ul class="nav flex-column nav-pills">
                            <li v-for="tab in tabs" class="nav-item">
                                <router-link :to="{ name: tab.route }" class="nav-link" active-class="active">
                                    <icon :name="tab.icon"></icon>
                                    {{ tab.name }}
                                </router-link>
                            </li>
                        </ul>
                    </div>

                    <div class="col-md-9">
                        <transition name="fade" mode="out-in">
                            <router-view></router-view>
                        </transition>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        loading: false,
        layout: 'default',
        name: 'UserDashboard',

        data () {
            return {
                tabs: [
                    {
                        icon: 'gym',
                        name: this.$t('create_gym'),
                        route: 'catalog.gym.create'
                    },

                    {
                        icon: 'list',
                        name: this.$t('my_gyms'),
                        route: 'user.gyms.list'
                    },

                    {
                        icon: 'user',
                        name: this.$t('profile'),
                        route: 'user.profile'
                    },
                    {
                        icon: 'lock',
                        name: this.$t('change_password'),
                        route: 'user.password'
                    },
//                    {
//                        icon: 'envelope',
//                        name: this.$t('subscriptions'),
//                        route: 'user.subscriptions'
//                    }
                ]
            }
        },

        methods: {
            //
        }
    }
</script>

<style>
    .settings-card .card-body {
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/user/dashboard.vue